// extracted by mini-css-extract-plugin
export var externalLink = "_66-0";
export var internalLinkLabel = "_66-1";